import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MenuState {
  menus: any[]
  currentMenu: any | null
  isLoading: boolean
  error: string | null
}

const initialState: MenuState = {
  menus: [],
  currentMenu: null,
  isLoading: false,
  error: null,
}

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setCurrentMenu: (state, action: PayloadAction<any | null>) => {
      state.currentMenu = action.payload
    },
  },
})

export const { clearError, setCurrentMenu } = menuSlice.actions
export default menuSlice.reducer
